import {
  MobileWhiteCardLineContainer,
  MobileWhiteCardLineLabel,
  MobileWhiteCardLineValue,
} from './styles'

interface MobileWhiteCardLineProps {
  label: string
  value: string | number | React.ReactElement | null
}

function MobileWhiteCardLine({ label, value }: MobileWhiteCardLineProps) {
  return (
    <MobileWhiteCardLineContainer>
      <MobileWhiteCardLineLabel>{label}</MobileWhiteCardLineLabel>
      <MobileWhiteCardLineValue>{value || '-'}</MobileWhiteCardLineValue>
    </MobileWhiteCardLineContainer>
  )
}

export default MobileWhiteCardLine
